import LegalPageLayout from './LegalPageLayout';
import { TermsContent } from './terms-content';

export default function TermsOfServicePage() {
  return (
    <LegalPageLayout title="Terms of Service" lastUpdated="January 16, 2026">
      <TermsContent />
    </LegalPageLayout>
  );
}
